"use client";

import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface AppSelectOption {
  label: string;
  value: string;
}

const sizeMap = {
  sm: { height: "lg:h-10 h-8", text: "text-sm" },
  md: { height: "xl:h-[50px] md:h-[44px] h-[40px]", text: "text-sm" },
  lg: { height: "lg:h-[54px] md:h-[48px] h-[44px]", text: "text-base" },
};

export interface AppSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: AppSelectOption[];
  placeholder?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  size?: keyof typeof sizeMap;
  className?: string;
  disabled?: boolean;
}

export function AppSelect({
  value,
  onValueChange,
  options,
  placeholder,
  startIcon,
  endIcon,
  size = "lg",
  className,
  disabled = false,
}: AppSelectProps) {
  const { height, text } = sizeMap[size];
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        className={[
          "w-auto gap-1.5 border-border-light px-[14px] cursor-pointer hover:border-border",
          height,
          text,
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {startIcon && (
          <span className="text-muted-foreground shrink-0 flex items-center">
            {startIcon}
          </span>
        )}
        <SelectValue placeholder={placeholder} />
        {endIcon && (
          <span className="text-muted-foreground shrink-0 flex items-center">
            {endIcon}
          </span>
        )}
      </SelectTrigger>
      <SelectContent className="p-0 bg-background">
        {options.map((opt, idx) => (
          <React.Fragment key={opt.value}>
            <SelectItem
              value={opt.value}
              className="pr-4 py-4 cursor-pointer  hover:bg-border-light focus:bg-border-light rounded-none border-0 font-medium text-base "
            >
              {opt.label}
            </SelectItem>
            {idx < options.length - 1 && (
              <div className="h-px bg-border-light" />
            )}
          </React.Fragment>
        ))}
      </SelectContent>
    </Select>
  );
}
